import React, { Component } from "react";
import api from "../../services/api";
import { withRouter } from '../../common/with-router';
import {Card, Row, Col, Modal, Form, Button, Spinner, Table, Badge} from "react-bootstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { FiFileText, FiUsers, FiCalendar, FiActivity, FiImage } from "react-icons/fi";
import { getCurrentUser, formataDataHoraExibicao, formatFileSize } from '../../common/utils';
import { FaEraser, FaPlus, FaSearch, FaFilePdf, FaFileExcel } from "react-icons/fa";
import AsyncSelect from 'react-select/async';

ChartJS.register(ArcElement, Tooltip, Legend);

class Arquivos extends Component {
    constructor(props) {
        super(props);

        const hoje = new Date();
        const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1).toISOString().split('T')[0];
        const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).toISOString().split('T')[0];

        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            loading: true,
            error: "",
            listRegistros: [],
            filtro_nome: "",
            filtro_data_de: "",
            filtro_data_ate: "",
            filtro_programa_id: "",
            filtro_programa_nome: "",
            filtro_tipo_conteudo: "",
            filtro_tipo_conteudo_nome: "",
            filtro_data_inicio: primeiroDiaMes,
            filtro_data_fim: ultimoDiaMes,
            showModalArquivos: false,
            dadosItemModal: {},
            page_numb: 1,
        };
    }

    componentDidMount(){
        this.consultaArquivos(this.state.busca, this.state.page_numb)
        /*
        this.props.toggleFullScreenMode(true);*/
        
    }

    handleCloseModalArquivos = () => {
        this.setState({ showModalArquivos: false });
    };

    handleShowModalArquivos = (item) => {
        this.handleCloseModalArquivos();
        this.setState({ 
            showModalArquivos: true,
            dadosItemModal: item
        });
    };
    
    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'tipo_conteudo') {
            this.setState(prevState => ({
                filtro_tipo_conteudo: event.value, 
                filtro_tipo_conteudo_nome: event.label, 
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
            }));
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    filtrarArquivos = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
            page_numb: 1,
        })

        this.consultaArquivos()
    };

    limpaFiltro = (e) => {
        const hoje = new Date();
        const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1).toISOString().split('T')[0];
        const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).toISOString().split('T')[0];

        this.setState({
            loading: true,
            filtro_nome: "",
            filtro_data_de: "",
            filtro_data_ate: "",
            filtro_programa_id: "",
            filtro_programa_nome: "",
            filtro_tipo_conteudo: "",
            filtro_tipo_conteudo_nome: "",
            filtro_data_inicio: primeiroDiaMes,
            filtro_data_fim: ultimoDiaMes,
            page_numb: 1,
        }, () => {
            this.consultaArquivos()
        });        
    };

    consultaArquivos = (page_numb = 1) => {
        const dados_usuario = getCurrentUser();

        const tipo = (dados_usuario?.tipo_usuario || '').toLowerCase();
        const isAdmin = tipo === '';

        this.setState({ loading: true, error: "" });

        let filtros = `?page=${page_numb}&page_size=20`;

        if (isAdmin || (!dados_usuario.is_superuser && dados_usuario.tipo_usuario === 'administrador')) {
            if (this.state.filtro_programa_id) {
                filtros += `&programa_id=${this.state.filtro_programa_id}`;
            }
        } else {
            if (dados_usuario?.ambiente_programa_id) {
                filtros += `&programa_id=${dados_usuario.ambiente_programa_id}`;
            }
        }

        if (this.state.filtro_tipo_conteudo) {
            filtros += `&tipo_conteudo=${this.state.filtro_tipo_conteudo}`;
        }

        if (this.state.filtro_data_inicio) {
            filtros += `&data_de=${this.state.filtro_data_inicio}`;
        }

        if (this.state.filtro_data_fim) {
            filtros += `&data_ate=${this.state.filtro_data_fim}`;
        }

        if (this.state.filtro_nome){
            filtros += `&search=${this.state.filtro_nome}`;
        }

        api.get(`/midias/${filtros}`)
        .then((response) => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data,
                page_numb,
            });
        })
        .catch((error) => {
            let erro_msg = 'Erro ao consultar os arquivos, tente novamente.';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 403) {
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                    loading: false,
                    error: erro_msg,
            });
        });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaArquivos(num_page);
    }

    getFileExtension = (url) => {
        try {
            const urlObj = new URL(url);
            const pathname = urlObj.pathname; // pega só o path sem query params
            const extension = pathname.split('.').pop();
            return extension.toLowerCase();
        } catch (error) {
            return null;
        }
    };

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            const dict_programas = this.state.listRegistros.programas

            return this.state.listRegistros.results.map((item) => {     
                // {
                //     "id": "pessoas.clientes.26.imagem",
                //     "model": "clientes",
                //     "app_label": "pessoas",
                //     "instance_id": 26,
                //     "field_name": "imagem",
                //     "url": "https://adh-hlg.s3.amazonaws.com/private/2025/11/13/Captura_de_tela_2025-11-13_114313.png?AWSAccessKeyId=ASIAY4VILZ4RR624Q4YF&Signature=mdcs8h3CPAmgcutwadrRWpj5%2FdM%3D&x-amz-security-token=IQoJb3JpZ2luX2VjEDMaCXNhLWVhc3QtMSJIMEYCIQDmDubK357z%2Bw5hBEuPYEsVpg2My3scUdXt3fRh7Y8ZfAIhAPr6Mcp6Me1pzSBTrrhbzuqkW1Vp%2F7KexYE0xmUoEYjtKv4DCPz%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMNjExMzEyMTkzMzE1IgzcrN2dqcB1WXi12j0q0gPm%2B%2FQPkLMYbzgBWudXg6IJePH%2FyRzR0uwdEJeec1ZhQO9HtGLrb2G17yFVVxelg6%2FMTCm8nHr5Ice4cwE%2FC%2BEVWZbhlf5gcG53AeOUYLYXQlCwcOTWNrK0DAdJ3FsBfl8t4DGLr%2Fnb70pdNk5YeU0mizov28kZRXWd6lFpj8PXukkeZFkQ1M0XXKr%2B8g1ulxWeiEz0ZJve1sg5uHWQgUTclfgUMMTQDBlmI6ArUz27mbj5SSYQf96ul5m1RHWMUbqP9B8KAYwrtIxGEKXgOTeG8%2F0WYCYfbqu42X0oVj3%2B%2B3JSnJZF2%2FCCLOCDDt1f83akRvbYIM0Op9tCPPWMcoe5lGIbXJ%2F0v2Lmr3%2FYjTSDtzqurrYPQmBAco2sXk%2BKgZ1H0TX%2BTf5Gry3urOoKSHIk8JwdN3k5pquhW8JJwFju7N2PWJPjgW41vsFWU5sny%2FK7R3pInJyWtjGJZ1CZF3aKYnda4IKjAVOxu0FOJUxQtg9krw3wnjJZNsynjbpb20pwADXd%2BxHm%2F2pkNpWmvyfv5wS2R25N3Ifzuyeh2CjCPfz5cB2b%2Fx7YmFWtCZdraa%2BDsb0tTKN40ZA%2BOW0oZcrI2hoDp2dPehZwJ%2BBLfj%2FGDU7hMLOhh8wGOqQBGo%2BC%2BHVpaHhsCAtQH%2Bbe3LZcDGy6rJoV8lgMJpJAoVmJeUcZgQlyPUW6Wv02HNGlaTIHJsLElErF%2BJuOl6jckZMeQQ3ALW3Zq4tt7MRgvXeEzyhDs5KPPAsvqloyMZ1P0yodweiwkMFOXPCgJKa30KQVRt8tw%2F1FesMJPy1HNX70b98%2FdbEANApwn1upm6nZpC7SMIopzYdrruyhpr4uSYATdAs%3D&Expires=1770125610",
                //     "name": "2025/11/13/Captura_de_tela_2025-11-13_114313.png",
                //     "size": 187846,
                //     "type": "image",
                //     "uploaded_at": null,
                //     "programa_id": null
                // }

                const uploaded_at = item.uploaded_at ? formataDataHoraExibicao(item.uploaded_at) : 'Data não informada';                
                const nome_programa = (item.programa_id && item.programa_id in dict_programas) ? dict_programas[item.programa_id] : 'Sem programa'
                const ext = this.getFileExtension(item.url);

                const obj_classes = {
                    'pdf': 'pdf',
                    'png': 'linha4',
                    'jpg': 'linha4',
                    'jpeg': 'linha4',
                    'xlsx': 'xlsx',
                    'xls': 'xlsx',
                }

                const icone = (ext in obj_classes) ? obj_classes[ext] : 'linha3'

                let nome_local = ''

                if(item.app_label == 'hiplatform'){
                    nome_local = 'HiPlatform'
                }
                else if(item.app_label == 'gotoconnect'){
                    nome_local = 'GotoConnect'
                }
                else if(item.app_label == 'microsoftExchange'){
                    nome_local = 'E-mail'
                }                
                else {
                    nome_local = 'HNS'
                }
                
                return (
                    <Col xs={12} sm={6} lg={3} className="mb-4" key={item.id}>
                        <Card className="arquivo-card">
                            <Card.Body onClick={() => this.handleShowModalArquivos(item)} role="button">
                                <div className="arquivo-header">
                                    <div className={`arquivo-icon ${icone}`}>
                                        <FiFileText  />
                                    </div>
                                    <div className="arquivo-nome">
                                        {item.name}
                                    </div>
                                </div>

                                <span className="badge badge-hiplatform">{nome_local}</span>
                                <div className="arquivo-info">
                                    {nome_programa} • {uploaded_at}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                )
            });
        }        

        return (
            <div className="mb-3 text-muted">
                Nenhum termo encontrado
            </div>
        );
    };

    carregarProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    carregarTiposConteudo = async (inputValue) => {
        return [
            {
                value: "hiplatform",
                label: "Hiplatform"
            },
            {
                value: "gotoconnect",
                label: "Gotoconnect"
            },
            {
                value: "email",
                label: "E-mail"
            },
            {
                value: "hns",
                label: "HNS"
            }
        ]
    };

    render() {
        const customStyles = {
            option: (provided) => ({
                ...provided,
                fontSize: '13px',
            }),
            singleValue: (provided) => ({
                ...provided,
                fontSize: '13px',
            }),
        };

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Repositório de Arquivos</h4>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>    
                        <h4>Buscar arquivos:</h4>
                        <Form method="get" onSubmit={this.filtrarArquivos}>
                            <Row>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregarProgramas}
                                            defaultOptions
                                            name="programa_id"
                                            placeholder="Nome do Programa"
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo de Conteúdo</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregarTiposConteudo}
                                            defaultOptions
                                            name="tipo_conteudo"
                                            placeholder="Tipo de Conteúdo"
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'tipo_conteudo')}
                                            value={this.state.filtro_tipo_conteudo ? { value: this.state.filtro_tipo_conteudo, label: this.state.filtro_tipo_conteudo_nome } : null}
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>

                                
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data De</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="filtro_data_inicio"
                                            value={this.state.filtro_data_inicio}
                                            onChange={e => this.handleChangeFiltros(e, 'filtro_data_inicio')}

                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Até</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="filtro_data_fim"
                                            value={this.state.filtro_data_fim}
                                            onChange={e => this.handleChangeFiltros(e, 'filtro_data_fim')}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome do Arquivo</Form.Label>                            
                                        <Form.Control
                                            type="text"
                                            name="filtro_nome"
                                            value={this.state.filtro_nome}
                                            onChange={this.handleChangeFiltros}
                                            placeholder="Nome do Arquivo"

                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Button variant="primary" type="submit" className="btn-submit" size="sm" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <>
                                        <FaSearch className="me-2" /> Filtrar
                                    </>
                                )}
                            </Button>
                            <Button variant="light" type="submit" className="ms-2" size="sm" disabled={this.state.loading} onClick={() => this.limpaFiltro()}>
                                <FaEraser /> Limpar filtro
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>

                { 
                    ('results' in this.state.listRegistros && !this.state.loading) && 
                    <div className="mb-3 text-muted">
                        {'Exibindo '+this.state.listRegistros.results.length+' arquivo(s) - Página '+this.state.page_numb}
                    </div>
                }                  

                {this.state.loading ? (
                <div className="mb-3 text-muted">
                    Carregando...
                </div>
                ) : (
                    this.state.error ? (
                        <div className="mb-3 text-muted">
                            {this.state.error}
                        </div>
                    ) : 
                    <>
                    <Row>
                        {this.renderRows()}
                    </Row>
                    {(this.state.listRegistros.previous || this.state.listRegistros.next) && (
                        <div className="d-flex justify-content-center align-items-center mt-3 gap-3">
                            <Button 
                                variant="outline-primary" 
                                size="sm" 
                                disabled={!this.state.listRegistros.previous}
                                onClick={() => this.onClickPagina(this.state.page_numb - 1)}
                            >
                                &laquo; Anterior
                            </Button>
                            <span className="text-muted">Página {this.state.page_numb}</span>
                            <Button 
                                variant="outline-primary" 
                                size="sm" 
                                disabled={!this.state.listRegistros.next}
                                onClick={() => this.onClickPagina(this.state.page_numb + 1)}
                            >
                                Próxima &raquo;
                            </Button>
                        </div>
                    )}
                    </>
                )}        

                <Modal size="lg" show={this.state.showModalArquivos} onHide={this.handleCloseModalArquivos}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {`Arquivo ` + this.state.dadosItemModal.name}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>                        
                        <p>
                            <strong>Modelo: </strong>{this.state.dadosItemModal.model}
                        </p>
                        <p>
                            <strong>Descrição do app: </strong>{this.state.dadosItemModal.app_label}
                        </p>
                        <p>
                            <strong>ID: </strong>{this.state.dadosItemModal.instance_id}
                        </p>
                        <p>
                            <strong>Nome do campo: </strong>{this.state.dadosItemModal.field_name}
                        </p>
                        <p>
                            <strong>Link: </strong><a href={this.state.dadosItemModal.url} target="_blank">Abrir arquivo</a>
                        </p>
                        <p>
                            <strong>Tamanho: </strong>{formatFileSize(this.state.dadosItemModal.size)}
                        </p>
                        <p>
                            <strong>Tipo: </strong>{this.state.dadosItemModal.type}
                        </p>
                        <p>
                            <strong>Data do upload: </strong>
                            {this.state.dadosItemModal.uploaded_at ? formataDataHoraExibicao(this.state.dadosItemModal.uploaded_at) : 'Data não informada'}
                        </p>
                        <p>
                            <strong>Id do programa: </strong>
                            {this.state.dadosItemModal.programa_id ? this.state.dadosItemModal.programa_id : 'Sem programa'}
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary-outline" onClick={this.handleCloseModalArquivos}>
                            Fechar
                        </Button>                        
                    </Modal.Footer>
                </Modal>          
            </div>
        );
    }
}

export default withRouter(Arquivos);